import { Observable } from 'rxjs';

export abstract class VacationRequestsPopupService {
  abstract openOpportunity(
    id: string | null,
    tab?: string
  ): Observable<unknown>;

  abstract openToDo(
    id: string
  ): Observable<unknown>;

  abstract openProspect(
    customerId: string
  ): Observable<unknown>;

  abstract openSalesOrder(
    salesOrderId: string
  ): Observable<unknown>;
}